import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getSellerListing } from '../tradingEndpoints'
import { parseSellerListingDetail } from '../tradingParser'

// One seller listing — the buy drawer quotes against it. A sold-out or
// withdrawn listing answers 409 MARKETPLACE_LISTING_UNAVAILABLE.
export function useSellerListingQuery(listingId: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: computed(() => tradingKeys.sellerListing(toValue(listingId))),
    queryFn: () => getSellerListing(toValue(listingId)).then(parseSellerListingDetail),
    enabled: () => Boolean(toValue(listingId)),
  })
}
